import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { DataEntity_Detail_09_Interface, Empty_DataEntity_Detail_09_Interface } from 'src/app/Interface/DataEntity/09/DataEntity_Detail_09_Interface';
import { DataEntity_Main_09_Interface, Empty_DataEntity_Main_09_Interface } from 'src/app/Interface/DataEntity/09/DataEntity_Main_09_Interface';
import { DataEntity_Resolution_09_Interface, Empty_DataEntity_Resolution_09_Interface } from 'src/app/Interface/DataEntity/09/DataEntity_Resolution_09_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DataEntity09Service } from 'src/app/Service/DataEntity/09/DataEntity09.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-DataEntity09',
  templateUrl: './DataEntity09.component.html',
  styleUrls: ['./DataEntity09.component.scss']
})
export class DataEntity09Component implements OnInit {

  constructor(
    private Calibration_Service: CalibrationService,
    private DataEntity09_Service: DataEntity09Service,
    private DataEntityMain_Service: DataEntityMainService,
    private Alerify_Service: AlertifyService,
    private Unit_Service: UnitService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) { }
  FileName: string = '';

  FolderName: string = '';



  CertificateCode: String = '';
  CertificateUrlPdf: string = ''

  Manufacture_txt: String = '';
  Type_txt: String = '';
  Model_txt: String = '';


  has_before: number = 0;
  DataEntity_Id: number = 12;

  InProccessing: boolean = false;
  Calibration_Device_Id: number = 0;
  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();
  Calibration_Id: number = 0;
  Observation: number = 0;


  unit_nominal: string = ''
  unit_error: string = ''




  ngOnInit() {

    this.MainFormDataEntity = new FormGroup({
      id: new FormControl(),

      Temperature_Air_before: new FormControl(null, [Validators.required]),
      Temperature_Air_after: new FormControl(null, [Validators.required]),

      Humidity_Air_before: new FormControl(null, [Validators.required]),
      Humidity_Air_after: new FormControl(null, [Validators.required]),

      Pressure_before: new FormControl(null, [Validators.required]),
      Pressure_after: new FormControl(null, [Validators.required]),

    });

    this.ResolutionFormDataEntity = new FormGroup({
      range_max: new FormControl(''),
      range_min: new FormControl(''),
      scale: new FormControl(null, [Validators.required]),
    });

    this.Calibration_Device_Id = Number(this.route.snapshot.paramMap.get('id'));
    this.Calibration_Service.GetSingleCalibrationDetail(this.Calibration_Device_Id
    ).subscribe(
      (data) => {
        this.Calibration_Device = data;
        this.OnIntial();
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  OnIntial() {
    this.DataEntity09_Service.GetSingle(this.Calibration_Device_Id, this.DataEntity_Id).subscribe(
      (data) => {
        if (data['result'] != null) {
          var temp: DataEntity_Main_09_Interface = Empty_DataEntity_Main_09_Interface();
          this.Observation = data['observation'];
          this.DataList_Resolution = data['resolution'];


          this.Nominal_Value_List = []

          temp = data['result'];
          this.Calibration_Id = temp.id;
          this.FileName = temp.filename;
          this.FolderName = temp.pdf_src;


          this.unit_error = temp.unit_error;
          this.unit_nominal = temp.unit_nominal;



          if (data['result']['before']==true)
            this.has_before = 1;
          else
            this.has_before = 0;



          this.Manufacture_txt = temp.manufacture;
          this.Type_txt = temp.type;
          this.Model_txt = temp.model;


          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""



          this.get_Form_Temperature_Air_before().setValue(temp['temperature_Air_before']);
          this.get_Form_Temperature_Air_after().setValue(temp['temperature_Air_after']);

          this.get_Form_Humidity_Air_before().setValue(temp['humidity_Air_before']);
          this.get_Form_Humidity_Air_after().setValue(temp['humidity_Air_after']);

          this.get_Form_Pressure_before().setValue(temp['pressure_before']);
          this.get_Form_Pressure_after().setValue(temp['pressure_after']);



          for (let item of data['detail']) {
            var tempDetail: DataEntity_Detail_09_Interface = Empty_DataEntity_Detail_09_Interface();


            tempDetail.reference_Value = item['reference_Value'];
            tempDetail.mesured = item['mesured'];
            tempDetail.uncertainty = item['uncertainty'];
            tempDetail.converage = item['converage'];

            this.Nominal_Value_List.push(tempDetail);
          }
        }
        this.Read_Unit()
        this.CertificateCode = data['certificate_Code'];
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  //#region Main Data Entity

  Nominal_Value_List: Array<DataEntity_Detail_09_Interface> = [];

  temp_Nominal_Value_List: Array<DataEntity_Detail_09_Interface> = [];
  MainFormDataEntity: FormGroup;

  get_Form_Temperature_Air_before() {
    return this.MainFormDataEntity.get('Temperature_Air_before') as FormControl;
  }
  get_Form_Temperature_Air_after() {
    return this.MainFormDataEntity.get('Temperature_Air_after') as FormControl;
  }

  get_Form_Humidity_Air_before() {
    return this.MainFormDataEntity.get('Humidity_Air_before') as FormControl;
  }
  get_Form_Humidity_Air_after() {
    return this.MainFormDataEntity.get('Humidity_Air_after') as FormControl;
  }

  get_Form_Pressure_before() {
    return this.MainFormDataEntity.get('Pressure_before') as FormControl;
  }
  get_Form_Pressure_after() {
    return this.MainFormDataEntity.get('Pressure_after') as FormControl;
  }



  //#endregion

  //#region Upload

  Procssing_Import: boolean = false
  upload_file_excel(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import = true

    this.DataEntity09_Service.uploadFile(formData).subscribe(
      data => {
        this.Procssing_Import = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Nominal_Value_List = []
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")

          this.FileName = data['filename']         

          for (let item of data['nominal']) {
            var temp: DataEntity_Detail_09_Interface = Empty_DataEntity_Detail_09_Interface()


            temp.reference_Value = item['reference_Value']
            temp.mesured = item['mesured']
            temp.uncertainty = item['uncertainty']
            temp.converage = item['converage']
            this.Nominal_Value_List.push(temp)

          }



        }
      }
    )

  }

  Procssing_Import2: boolean = false
  upload_file_pdf(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import2 = true

    this.DataEntity09_Service.uploadPdf(formData).subscribe(
      data => {
        this.Procssing_Import2 = false
        if (data['filename']) {
          this.Alerify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alerify_Service.SuccessMessage("اطلاعات خوانده شد")
          this.FolderName = data['fodlername']

        }
      }
    )

  }

  //#endregion

  //#region Unit

  DataList_Unit: Array<Unit_Interface> = []
  Read_Unit() {
    this.Unit_Service.GetDataEntity(this.DataEntity_Id).subscribe(
      data => {
        this.DataList_Unit = data
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#endregion

  //#region Resolution 
  ResolutionFormDataEntity: FormGroup;
  DataList_Resolution: Array<DataEntity_Resolution_09_Interface> = []

  temp_DataList_Resolution: Array<DataEntity_Resolution_09_Interface> = []

  Delete_Resolution(id: number) {
    this.DataList_Resolution.splice(id, 1)
    this.Alerify_Service.SuccessMessage("حذف شد")
  }

  Add_Resolution() {

    var temp_DataList_Resolution: Array<DataEntity_Resolution_09_Interface> = []
    temp_DataList_Resolution = this.DataList_Resolution

    var CanAdd: Boolean = true
    for (let item of temp_DataList_Resolution) {
      if (Number(item.range_min) <= Number(this.get_Form_range_min().value) && Number(this.get_Form_range_min().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
      else if (Number(item.range_min) <= Number(this.get_Form_range_max().value) && Number(this.get_Form_range_max().value) <= Number(item.range_max)) {
        CanAdd = false
        break;
      }
    }

    if (temp_DataList_Resolution.length >= 7) {
      this.Alerify_Service.ErrorMessage("حداکثر ۷ مورد رنج و رزلوشن می تواند ثبت کرد!")
    }
    else if (CanAdd) {

      var temp: DataEntity_Resolution_09_Interface = Empty_DataEntity_Resolution_09_Interface()
      temp.range_min = this.get_Form_range_min().value + ''
      temp.range_max = this.get_Form_range_max().value + ''
      temp.scale = this.get_Form_scale().value + ''
      this.DataList_Resolution.push(temp)

      this.Alerify_Service.SuccessMessage("اطلاعات ثبت شد")
    }
    else {
      this.Alerify_Service.ErrorMessage("اطلاعات جدید با اطلاعات موجود همپوشانی دارد")
    }
  }


  get_Form_range_min() {
    return this.ResolutionFormDataEntity.get('range_min') as FormControl;
  }

  get_Form_range_max() {
    return this.ResolutionFormDataEntity.get('range_max') as FormControl;
  }

  get_Form_scale() {
    return this.ResolutionFormDataEntity.get('scale') as FormControl;
  }

  Visible_Nominal_Value_List(id: number) {
    this.Nominal_Value_List[id].mesured_visible =
      !this.Nominal_Value_List[id].mesured_visible;
  }


  //#endregion

  //#region LabAddress

  Set_LabAddress_click(input:string) {
    this.Calibration_Device.labAdderss=input

  }

  //#endregion

  modalRef_CodeSerial: any;
  modalRef_CodeSerial_Title: any;
  modalRef_Code: any;

  onSubmit(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {

    if ((!this.Calibration_Device.device_serial || !this.Calibration_Device.device_code || this.Calibration_Device.device_serial.trim() == "" || this.Calibration_Device.device_code.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار سریال یا کد دستگاه  ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else if ((!this.Model_txt || this.Model_txt.trim() == "") && id == 0) {
      this.modalRef_CodeSerial_Title = "مقدار MODEL  ثبت نشده است "
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else {
      this.InProccessing = true;
      var temp: DataEntity_Main_09_Interface = Empty_DataEntity_Main_09_Interface();

      temp.id = this.Calibration_Id;

      temp.unit_error = this.unit_error;
      temp.unit_nominal = this.unit_nominal;



      temp.temperature_Air_before = this.get_Form_Temperature_Air_before().value;
      temp.temperature_Air_after = this.get_Form_Temperature_Air_after().value;

      temp.humidity_Air_before = this.get_Form_Humidity_Air_before().value;
      temp.humidity_Air_after = this.get_Form_Humidity_Air_after().value;

      temp.pressure_before = this.get_Form_Pressure_before().value;
      temp.pressure_after = this.get_Form_Pressure_after().value;


      temp.before = Number(this.has_before)


      this.temp_DataList_Resolution = []
      for (let item of this.DataList_Resolution) {
        this.temp_DataList_Resolution.push(item)
      }

      this.temp_Nominal_Value_List = []
      for (let item of this.Nominal_Value_List) {
        this.temp_Nominal_Value_List.push(item)
      }


      this.DataEntity09_Service.Submit(
        temp,
        this.temp_Nominal_Value_List,
        this.temp_DataList_Resolution,
        this.DataEntity_Id,
        this.Calibration_Device_Id,
        this.FileName,
        this.FolderName,
        this.Calibration_Device.device_serial,
        this.Calibration_Device.device_code,
        this.Manufacture_txt,
        this.Type_txt,
        this.Model_txt,
        this.Calibration_Device.labAdderss).subscribe((data) => {
          this.InProccessing = false;
          if (data['id'] == -1) {
            this.Alerify_Service.ErrorMessage(data['dsc'])
          }
          else if (data['certificate_Code'] == '') {
            this.Alerify_Service.ErrorMessage('خطا سیستمی');
          } else {
            this.CertificateCode = data['certificate_Code'];
            this.Alerify_Service.SuccessMessage('اطلاعات ثبت شد');

            this.OnIntial()

            if (data['certificateUrl'])
              this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
            else
              this.CertificateUrlPdf = ""

            this.modalRef_Code = this.modalService.show(template);
          }
        });

    }
  }

  onSubmit_Code(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {
    this.onSubmit(template, templateCodeSerial, 1)
    this.modalRef_CodeSerial.hide()
  }


}
